var exports = {
  "kL": "WebhookListItem.module__container___cXBTYX",
  "aY": "WebhookListItem.module__headerButton___cXBTYX",
  "kb": "WebhookListItem.module__left___cXBTYX",
  "Jb": "WebhookListItem.module__avatarLarge___cXBTYX",
  "fI": "WebhookListItem.module__textBlock___cXBTYX",
  "$": "WebhookListItem.module__titleRow___cXBTYX",
  "UU": "WebhookListItem.module__name___cXBTYX",
  "ML": "WebhookListItem.module__channelTag___cXBTYX",
  "KW": "WebhookListItem.module__metaRow___cXBTYX",
  "K9": "WebhookListItem.module__channelTagMobile___cXBTYX",
  "ai": "WebhookListItem.module__chevron___cXBTYX",
  "hg": "WebhookListItem.module__chevronExpanded___cXBTYX",
  "zH": "WebhookListItem.module__details___cXBTYX",
  "J1": "WebhookListItem.module__detailsRow___cXBTYX",
  "Mc": "WebhookListItem.module__avatarColumn___cXBTYX",
  "Pf": "WebhookListItem.module__label___cXBTYX",
  "_Q": "WebhookListItem.module__avatarPreview___cXBTYX",
  "OA": "WebhookListItem.module__fields___cXBTYX",
  "EN": "WebhookListItem.module__fieldsRow___cXBTYX",
  "ch": "WebhookListItem.module__fieldGrow___cXBTYX",
  "o1": "WebhookListItem.module__actions___cXBTYX",
  "Dy": "WebhookListItem.module__avatarActions___cXBTYX",
  "B": "WebhookListItem.module__urlWrapper___cXBTYX",
  "UQ": "WebhookListItem.module__monoInput___cXBTYX",
  "Bx": "WebhookListItem.module__iconSmall___cXBTYX",
  "xv": "WebhookListItem.module__truncate___cXBTYX",
};

module.exports = exports;
